import { render, staticRenderFns } from "./DeliveryExecutives.vue?vue&type=template&id=37b9abb2&"
import script from "./DeliveryExecutives.vue?vue&type=script&lang=js&"
export * from "./DeliveryExecutives.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports